import * as React from "react";
import {SearchBar} from "../SearchBar/SearchBar";
import {ReactChild, ReactComponentElement, useEffect, useState} from "react";

export interface SlideMenuProps {
    children: ReactChild,
    title: string,
    onDismissedFunction: () => void,
    dismiss?: boolean
}

export const SlideMenu = (props: SlideMenuProps) => {
    const [dismiss, setDismiss] = useState(false);
    const ref = React.useRef<HTMLDivElement>();

    useEffect(() => {
        if (props.dismiss == true) {
            closeMenu();
        }
    }, [props.dismiss]);
    useEffect(() => {
        if (dismiss == true) {
            closeMenu();
        }
    }, [dismiss]);

    function closeMenu() {
        if (ref.current) {
            ref.current.classList.add('dismiss');
            setTimeout(() => {
                props.onDismissedFunction();
            }, 200);
        }
    }

    return (
        <div className="slide-menu" ref={ref}>
            <div className="header">
                <span>{props.title}</span>
                <span className="fas fa-times close" onClick={() => setDismiss(true)}/>
            </div>
            <div className="body">
                {props.children}
            </div>
        </div>
    )
}